import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { useTheme } from '@/contexts/ThemeContext'

export default function AuthLayout() {
  const { isAuthenticated, user } = useAuthStore()
  const { theme } = useTheme()

  // If already authenticated, redirect to dashboard
  if (isAuthenticated && user?.role !== 'pending') {
    return <Navigate to="/dashboard" replace />
  }

  // Default logo SVG component
  const DefaultLogo = () => (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="30" fill={theme.colors.sidebarBg} fillOpacity="0.1"/>
      <path d="M32 12L32 42" stroke={theme.colors.sidebarBg} strokeWidth="4" strokeLinecap="round"/>
      <path d="M22 24L32 12L42 24" stroke={theme.colors.sidebarBg} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20 52C20 47.5817 24.4772 44 30 44H34C39.5228 44 44 47.5817 44 52" stroke={theme.colors.sidebarBg} strokeWidth="3" strokeLinecap="round"/>
      <circle cx="32" cy="36" r="6" fill={theme.colors.sidebarBg}/>
    </svg>
  )

  return (
    <div
      className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8"
      style={{ backgroundColor: theme.colors.loginBg }}
    >
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          {/* Logo */}
          <div className="flex items-center justify-center mb-4">
            {theme.logoUrl ? (
              <img src={theme.logoUrl} alt={theme.companyName} className="h-16 object-contain" />
            ) : (
              <DefaultLogo />
            )}
          </div>
          <h1
            className="text-4xl font-bold flex items-center justify-center gap-2"
            style={{ fontFamily: "'Varela Round', sans-serif", color: theme.colors.loginText }}
          >
            {!theme.logoUrl && (
              <img src={`${import.meta.env.BASE_URL}scritta_conquist.png`} alt={theme.companyName} className="h-8" />
            )}
            <span>{theme.appName}</span>
          </h1>
          <p className="mt-2" style={{ color: theme.colors.loginText, opacity: 0.7 }}>
            {theme.tagline}
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div
          className="py-8 px-4 shadow-xl sm:rounded-lg sm:px-10"
          style={{ backgroundColor: theme.colors.loginCardBg, color: theme.colors.loginText }}
        >
          <Outlet />
        </div>
      </div>

      <p className="mt-8 text-center text-sm" style={{ color: theme.colors.loginText, opacity: 0.6 }}>
        &copy; {new Date().getFullYear()} {theme.appName} by{' '}
        <span className="font-bold" style={{ color: theme.colors.companyColorLogin }}>
          {theme.copyright}
        </span>{' '}
        Tutti i diritti riservati.
      </p>
    </div>
  )
}
